import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import slide_data from "./slide_data";
import {Link } from "react-router-dom";
import {Slide_data} from "./slide_data"

function Resizable():JSX.Element {
    const [width, setWidth] = useState<string>('100%');
    const [display, setDisplay] = useState<boolean>(true);

    const [slide] = useState<Slide_data[]>(slide_data);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,

    };
    return (
        <div>
            <div
                style={{
                    width: width + "px",
                    display: display ? "block" : "none"
                }}
            >
                <style>{cssstyle}</style>
                <Slider {...settings}>
                    {slide.map((slide, index) => (
                        <div className="slidebox">    
                        <Link to="/"><img src={`/types/img/main_new_0${index}.png`} width="100%" /></Link>
                        <div className="slidebox-txt">
                            <span>{slide.content}</span>
                            <p>{slide.title}</p>
                            <div className="slide-tag">
                                <Link to="/">{slide.tag}</Link>
                                <Link to="/">{slide.tag2}</Link>
                            </div>
                        </div>
                    </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
}

const cssstyle = `
.slick-slider {
    position: relative;
    overflow:hidden;
    height:800px;

    display: block;
    box-sizing: border-box;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
}
.slick-slide {
    display: none;
    float: left;

    margin-right:30px;
    height: 100%;
    min-height: 1px;
}
.slick-list {
    position: relative;

    display: block;
    overflow: hidden;
    
    margin-right: -50px;
    padding: 0;
}
.slick-dots {    
    position: absolute;
    bottom: 80px;

    display: block;

    width: 100%;
    padding: 0;
    margin: 0;

    list-style: none;

    text-align: center;
}
.slick-dots li
{
    position: relative;

    display: inline-block;

    width: 20px;
    height: 20px;
    margin: 0;
    padding: 0;

    cursor: pointer;
}
.slick-dots li button:before
{
    font-family: 'slick';
    font-size: 10px;
    line-height: 20px;

    position: absolute;
    top: 0;
    left: 0;

    width: 20px;
    height: 20px;

    content: '•';
    text-align: center;

    opacity: .25;
    color: #8581d5;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.slick-dots li.slick-active button:before
{
    opacity: .75;
    color: #8581d5;
}
.slick-track {
    position: relative;
    top: 0;
    left: 0;
    height:100%;

    display: block;
    margin-left: auto;
    margin-right: auto;
}

`

export default Resizable;
